import { render } from "./LandingCarousel.vue?vue&type=template&id=4879489e&scoped=true"
import script from "./LandingCarousel.vue?vue&type=script&lang=js"
export * from "./LandingCarousel.vue?vue&type=script&lang=js"

import "./LandingCarousel.vue?vue&type=style&index=0&id=4879489e&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4879489e"]])

export default __exports__